/**
 * ListPageToolbar
 *
 * Shared toolbar used by list-style pages (Sites, Devices, Users, ...).
 * Renders: title + total count on the left and a search / more / add /
 * view-toggle button row on the right.
 */
import { useState } from 'react';

function ListPageToolbar({
  title,
  total,
  onSearch,
  onAdd,
  onToggleView,
  view = 'list',
  showMore = true,
}) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState('');

  return (
    <div className="list-toolbar">
      <div className="list-toolbar-left">
        <button
          type="button"
          className="list-toolbar-search-btn"
          onClick={() => setSearchOpen((v) => !v)}
          title="Search"
        >
          <i className="fas fa-search"></i>
        </button>
        <div className="list-toolbar-heading">
          <h1>{title}</h1>
          {total != null && <span className="list-toolbar-total">{total} TOTAL</span>}
        </div>
      </div>
      <div className="list-toolbar-right">
        {searchOpen && (
          <input
            className="list-toolbar-search"
            autoFocus
            placeholder={`Search ${title.toLowerCase()}...`}
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              onSearch?.(e.target.value);
            }}
          />
        )}
        {showMore && (
          <button type="button" className="list-toolbar-icon-btn" title="More">
            <i className="fas fa-ellipsis-h"></i>
          </button>
        )}
        {onAdd && (
          <button type="button" className="list-toolbar-add-btn" onClick={onAdd} title="Add">
            <i className="fas fa-plus"></i>
          </button>
        )}
        {onToggleView && (
          <button
            type="button"
            className="list-toolbar-icon-btn"
            onClick={onToggleView}
            title={view === 'list' ? 'Grid view' : 'List view'}
          >
            <i className={`fas ${view === 'list' ? 'fa-th' : 'fa-list'}`}></i>
          </button>
        )}
      </div>
    </div>
  );
}

export default ListPageToolbar;

